define('views/modules/setting/business/blocks/custom-button/custom-button-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'src/views/form-view',
    'views/parts/menu/menu-save-action',
    'views/parts/form/textbox',
    'views/parts/form/choices',
    // templates
    'text!templates/modules/setting/business/blocks/custom-button/custom-button-edit-content.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VForm,
    VMenuSaveAction,
    VTextBox,
    VChoices,
    // templates
    TCustomButtonEditContent
) {

    var VCustomButtonEditContent = VForm.extend({
        template: TCustomButtonEditContent,

        regions: {
            root: ".custom-button-edit-content",
            menu: ".menu-actions",
            url: ".url-input",
            text: ".text-input",
            active: ".active-input"
        },

        initialize: function(options) {

            var model = this.model,
                view = this.view = {
                    menu: new VMenuSaveAction({
                        context: this,
                        onClick: this.onActionClick,
                        onSave: this.onSaveButton,
                        saveText: "Save",
                        radio: false,
                        tooltip: { container: this.regions.root, }
                    }),
                    url: new VTextBox({
                        label: 'form-custom-button-url',
                        attribute: 'customButtonUrl',
                        labelposition: 'top',
                        model: model,
                    }),
                    text: new VTextBox({
                        label: 'form-custom-button-text',
                        labelposition: 'top',
                        attribute: 'customButtonText',
                        model: model,
                        maxlength: 30,
                        help: 'messages:message-characters-limit'
                    }),
                    active: new VChoices({
                        label: "Active",
                        attribute: 'customButtonActive',
                        model: model
                    })
                };

            this.listenTo(model, { 'change': this.onModelChange });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.text, zone.$text)
                .assign(view.active, zone.$active)
                .assign(view.url, zone.$url);

            return this;
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onSaveButton: function() {
            this.model.get("customButton").text = this.view.text.getValue();
            this.submit();
        },
    });

    return VCustomButtonEditContent;
});

